import { useState, useEffect } from 'react';
import type { MfeVersionManagerInstanceType } from './types';

/**
 * This hook retrieves the version manager instance instantiated earlier. It is
 * a utility hook to encapsulate reading of the version manager global
 * @returns Instance of the mfe-version-manager
 */
export function useMfeVersionManager(): MfeVersionManagerInstanceType | null {
  const [manager, setManager] = useState<MfeVersionManagerInstanceType | null>(
    null
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setManager(
        (window as any).__MFE_VERSION_MANAGER__ as MfeVersionManagerInstanceType
      );
    }
  }, []);

  return manager;
}
